<template>
  <div v-if="serverData">
    <v-card
      class="rounded-md mb-3 mb-xl-0 shadow-none position-relative"
      @click="navigateToOrders"
      :class="{ 'mr-xl-6': index !== 4 && index !== 9 }"
    >
      <v-card-text class="px-6 pt-6 pb-0">
        <div class="mb-2 d-flex justify-content-between">
          <p class="font-size-h4 font-weight-medium mt-3 text-dark-50">
            {{ serverData.title }}
          </p>
          <img :src="serverData.icon" alt="icon" class="w-35px mb-2" />
          <!-- <div class="mt-1 d-flex">
            <div class="font-size-h5 font-weight-bolder green--text">+22%</div>
            <div
              class="font-size-h2 font-weight-bolder green--text mb-5 ml-1"
              style="transform: rotate(273deg)"
            >
              >
            </div>
          </div> -->
        </div>
        <div>
          <h1 class="title-counter text-dark-65 mb-0">
            {{ serverData.values }}
          </h1>
          <p class="font-size-lg">{{ serverData.caption }}</p>
        </div>
      </v-card-text>
      <apexchart
        type="area"
        height="100"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </v-card>
  </div>
  <v-skeleton-loader v-else type="card"></v-skeleton-loader>
</template>

<script>
// import { getToken } from "@/core/services/jwt.service";
// import axios from "axios";
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import { SET_TABLE_FILTER } from "@/core/services/store/returned.module";
import returnsFilterMixin from "@/own/mixins/returnsFilterMixin";

// import Swal from "sweetalert2";
export default {
  name: "FulfillmentOrdersCounterChartExtended",
  props: {
    item: { required: true },
    filterData: { required: true },
    index: { required: true },
    redirectUrl: { default: "/fulfillment/orders" },
  },
  mixins: [returnsFilterMixin],
  data: () => ({ serverData: null }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.loadDataFromServer();
  },
  methods: {
    loadDataFromServer() {
      let data = this.filterData;
      ApiService.post(`${this.item.url}`, data)
        .then((response) => {
          this.serverData = response.data.chart;
          setTimeout(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          }, 1000);
        })
        .catch(() => {});
    },
    navigateToOrders() {
      const status = this.getOrderStatus(this.item.name);
      const dateRange = this.getDateRange(this.filterData);

      if (status) {
        this.$store.commit(SET_PAGE_LOADING, true);

        const FILTERS = [];

        // * Status
        FILTERS.push(status);

        // * Date range
        FILTERS.push(dateRange);

        // * Warehouse
        if (this.filterData.warehouse) {
          let filterValues = [];

          if (this.filterData.warehouse === "all") {
            const warehouses = this.filters.warehouses.values.map(
              (warehouse) => warehouse.index
            );
            filterValues = warehouses.slice(1);
          } else {
            filterValues = [this.filterData.warehouse];
          }
          FILTERS.push({
            name: "warehouse",
            value: filterValues,
          });
        } else {
          FILTERS.push({
            name: "warehouse",
            value: [0],
          });
        }

        // * Client
        if (this.filterData.client) {
          let filterValues = [];

          if (this.filterData.client === "all") {
            const clients = this.filters.clients.values.map(
              (client) => client.index
            );
            filterValues = clients.slice(1);
          } else {
            filterValues = [this.filterData.client];
          }
          FILTERS.push({
            name: "client",
            value: filterValues,
          });
        }

        this.$store.commit(SET_TABLE_FILTER, FILTERS);
        this.$router.push("/shipping/return_orders");
      }
    },
  },
  computed: {
    isDataLoaded: function () {
      return !!this.serverData;
    },
    chartOptions: function () {
      return {
        chart: {
          height: "100",
          type: "area",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          sparkline: {
            enabled: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: [this.colorShade], // shade of line
        // colors: ["#F64E60"],
        stroke: {
          curve: "smooth",
          show: true,
          width: 3,
        },
        xaxis: {
          type: "category",
          // categories: this.serverData.categories,
          categories: [1, 2, 3, 4, 5],
          labels: {
            show: true,
            formatter: function (val) {
              const secondDigit = /^\d+$/.test(String(val).slice(1, 2))
                ? String(val).slice(1, 2)
                : "";

              return (
                String(val).slice(-3) +
                " " +
                String(val).slice(0, 1) +
                secondDigit
              );
            },
            style: {
              colors: "#b1b5c3",
              fontSize: "12px",
            },
          },
          crosshairs: {
            show: false,
            position: "front",
            stroke: {
              width: 1,
              dashArray: 3,
            },
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
            style: {
              colors: ["#afb2c1"],
              fontSize: "12px",
              fontWeight: 500,
            },
          },
        },
        fill: {
          // colors: this.colorShade,
          colors: this.colorShade, // the line color
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.9,
            opacityFrom: 0.8,
            opacityTo: 0,
            stops: [0, 90],
            colorStops: [],
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            // format: "dd MMM",
            formatter: (formatter) => this.serverData.categories[formatter - 1],
          },
          y: {
            formatter: function (value) {
              return value;
            },
            title: {
              formatter: () =>
                this.item.title === "Total sales" ? "Total sales:" : "Orders:",
            },
          },
        },
      };
    },
    series: function () {
      return [
        {
          name: "Orders",
          data: this.serverData.series[0].data,
        },
      ];
    },
    colorShade: function () {
      const data = this.serverData.series[0].data;
      if (data[0] < data[data.length - 1]) {
        return "#28a745";
      }
      if (data[0] === data[data.length - 1]) {
        return "#ffff4d";
      }
      return "#F64E60";
    },
  },
  watch: {
    filterData: {
      deep: true,
      immediate: false,
      handler(newData, oldData) {
        if (JSON.stringify(newData) !== JSON.stringify(oldData)) {
          this.serverData = null;
          this.loadDataFromServer();
        }
      },
    },
  },
};
</script>

<style scoped>
.border-circular {
  border-radius: 12px;
}
.title-counter {
  font-size: 3rem;
}
.rounded-md {
  border-radius: 0.6rem;
  box-shadow: rgb(76 78 100 / 22%) 0px 2px 10px 0px !important;
}
.icon-md {
  font-size: 2rem !important;
}
.text-dark-55 {
  color: #d1d1da;
}
</style>
